import { Component, ElementRef, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'hub-modal-form-parent',
  templateUrl: './modal-form-parent.component.html',
})
export class ModalFormParentComponent {
  /** Resize the height of the ion-modal to make sure modals fit to view. This will disable the translate animation. */
  public modalHeightFitToView: boolean = false;

  /** The element reference where to base the calculation of modal dialog float */
  public keyboardParentTarget: ElementRef;

  /** Subscription for keyboard show */
  private _keyboardShowSub: Subscription;

  /** Subscription for keyboard hide */
  private _keyboardHideSub: Subscription;

  /** The parent form group to use */
  public parentFormGroup: FormGroup = new FormGroup({});

  constructor(public platform: Platform, public modalCtrl: ModalController, public renderer: Renderer2) {
    // Listen to keyboard show
    this._keyboardShowSub = this.platform.keyboardDidShow.subscribe(async ev => {
      // get the existing dialog
      const modalDialog = await this.modalCtrl.getTop();

      // check if a target elem is specified, if no, we will use the focused element
      const targetElem = this.keyboardParentTarget ? this.keyboardParentTarget.nativeElement : document.activeElement;
      if (targetElem && targetElem.getBoundingClientRect && modalDialog) {
        const bottom: number = targetElem.getBoundingClientRect().bottom + 50; // add 50 as padding
        const difference: number = this.platform.height() - ev.keyboardHeight;
        if (bottom > difference) {
          if (this.modalHeightFitToView) {
            this.renderer.setStyle(modalDialog, 'height', `${difference}px`);
            this.renderer.addClass(modalDialog, 'modal-keyboard');
          } else {
            this.renderer.setStyle(modalDialog, 'transform', `translate3d(0, ${difference - bottom}px, 0)`);
          }
        }
      }
    });

    this._keyboardHideSub = this.platform.keyboardDidHide.subscribe(async ev => {
      this.reset();
    });
  }

  ngOnInit() {
    this.modalCtrl.getTop().then(modalDialog => {
      if (modalDialog) this.renderer.addClass(modalDialog, 'modal-keyboard');
    });
  }

  /** Reset the current state of the modal */
  async reset() {
    this.modalCtrl.getTop().then(modalDialog => {
      if (modalDialog) {
        if (this.modalHeightFitToView) {
          this.renderer.removeClass(modalDialog, 'modal-keyboard');
          this.renderer.setStyle(modalDialog, 'height', '100%');
        } else {
          this.renderer.setStyle(modalDialog, 'transform', `translate3d(0,0,0)`);
        }
      }
    });
  }

  ngOnDestroy() {
    this.reset();
    if (this._keyboardShowSub) this._keyboardShowSub.unsubscribe();
    if (this._keyboardHideSub) this._keyboardHideSub.unsubscribe();
  }
}
